import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';

export const SearchHeroBackgroundHolder = styled.div`
  position: absolute;
  transform: translateZ(0);
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const SearchHeroBackgroundImageHolder = styled.div`
  width: 100%;
  height: 100%;
`;

export const SearchHero_Box_1 = styled.div`
  width: 100%;
  padding-inline: 20px;
  padding-block: 20px;
  border-radius: 12px;
  box-shadow: 0 0 6px rgb(0 0 0 / 0.3);
  background: white;
  color: ${colors.mediumContentGrey};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: 50%;
    padding-inline: 60px;
    padding-block: 40px;
  }
`;

export const SearchHero_Box_2 = styled.div`
  max-width: 400px;
  width: 100%;
  margin: 0 auto;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    max-width: ${maxWidth[3]}px;
    padding-inline: ${gutterWidth}px;
  }
`;

export const SearchHero_Box_3 = styled.div`
  min-height: 470px;
  padding-top: 36px;
  padding-bottom: 36px;
  padding-inline: ${gutterWidth / 2}px;
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: white;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    min-height: calc(100vh - 300px);
    padding-top: 80px;
    padding-bottom: 64px;
    padding-inline: ${gutterWidth}px;
  }
`;
